//运维
import menus from "../pages/maintenance/menus/menus.vue";
import dataDictionary from "../pages/maintenance/dataDictionary/dataDictionary.vue";
import account from "../pages/maintenance/account/account.vue";
import attachment from "../pages/maintenance/attachment/attachment.vue";
import timerTaskManage from "../pages/maintenance/timerTaskManage/timerTaskManage.vue";
export default {
	path: "/maintenance",
	name: "maintenance",
	meta: { title: "运维" },
	children: [
		{
			path: "menus",
			meta: { title: "后台菜单" },
			component: menus,
		},
		{
			path: "dataDictionary",
			meta: { title: "数据字典" },
			component: dataDictionary,
		},
		{
			path: "account",
			meta: { title: "管理员账号" },
			component: account,
		},
		{
			path: "attachment",
			meta: { title: "附件管理" },
			component: attachment,
		},
		{
			path: "timerTaskManage",
			meta: { title: "定时任务管理" },
			component: timerTaskManage,
		},
	],
};
